import { logInDev } from '../utils/log-utils';

const SliceManager = (() => {
  let store = {};

  const injectedSlices = new Map();

  const hasSlice = (label) => !!injectedSlices.get(label);

  return {
    init: (appStore) => {
      store = appStore;
    },
    updateStore: (appStore) => {
      store = appStore;
    },
    injectSlice: (label, reducers, saga) => {
      if (hasSlice(label)) {
        logInDev(`${label} - SLICE ALREADY INJECTED - ABORTING INJECT`);
      } else {
        logInDev(`${label} - SLICE INJECTION SUCCESS`);
        injectedSlices.set(label, true);
        store.injectReducers(reducers);
        store.injectSaga(label, saga);
      }
    },
    removeSlice: (label, reducers) => {
      if (hasSlice(label)) {
        injectedSlices.delete(label);
        store.removeReducers(reducers);
      }
    },
    hasSlice,
  };
})();

export default SliceManager;
